import { render, staticRenderFns } from "./GetSelectedCustomer.vue?vue&type=template&id=ad73853a&scoped=true&"
import script from "./GetSelectedCustomer.vue?vue&type=script&lang=js&"
export * from "./GetSelectedCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad73853a",
  null
  
)

export default component.exports